import { makeAutoObservable, runInAction } from "mobx";
import agent from "../api/agent";
import { history } from "../..";
import { IPlayerLink, ISharedObject, zoomPortionValue } from "../models/dto";
import { IUserMeeting } from "../models/meeting";
import { RootStore } from "./rootStore";
import { IAttendingUser } from "../models/user";
import shareSyncStatus from "../models/shareSyncStatus";
import { ISearchOptions, ISearchPageDto } from "../models/search";
import moment from "moment";
import { offlineLinks } from "../models/offline";
import { INoteModalParams } from "../models/note";
import {
  ISharedWidgetVideo,
  SharedWidgetType,
  VideoWidgetCommandTypes,
} from "../models/widget";
import { toast } from "react-toastify";
import { inferAnnotationFromDescriptor } from "mobx/dist/internal";
import { Z_ERRNO } from "zlib";
import { ConsoleLogger } from "@microsoft/signalr/dist/esm/Utils";
import { t } from "i18next";

export default class PlayerStore {
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }

  playerLinks: IPlayerLink[] = [];
  canViewSurveys: boolean = false;
  meetingAttendanceModal: IUserMeeting | null = null;
  userMeetings: Map<number, IUserMeeting> = new Map<number, IUserMeeting>();
  attendingMeeting: IUserMeeting | null = null;

  sharedObject: ISharedObject | null = null;
  synchronizationObject: ISharedObject | null = null;
  sharedWidget: SharedWidgetType | null = null;
  currentsharedObject: ISharedObject | null = null;
  searching: boolean = false;
  searchResults: ISearchPageDto | null = null;
  selectedSearchPage: number = 0;

  showNoteModal: boolean = false;
  noteModalParams: INoteModalParams | null = null;

  enabledRepository: boolean = false;
  enabledArchiveButton: boolean = false;
  activeTab: string = "1";

  showPresentationModal: boolean= false;
  isZoomPortionEnabled: boolean= false;

  isBroadcastControllerOpen: boolean= false;

  storedsearchFormValues: ISearchOptions | null = null;
  
  IsStoredSearchResults: boolean = false;

  setStoredSearchResults = (value: boolean) => {
      this.IsStoredSearchResults = value;
  }

    setStoredSearchFormValues = (values: ISearchOptions) => { 
      this.storedsearchFormValues = values;

    }


  get isSharing() {
    if (this.attendingMeeting && this.attendingMeeting) {
      return this.attendingMeeting.shareSyncStatus === shareSyncStatus.Share;
    }
    return false;
  }


  get isSynced() {
    if (this.attendingMeeting && this.attendingMeeting) {
      return this.attendingMeeting.shareSyncStatus === shareSyncStatus.Sync;
    }
    return false;
  }


  get currentFileHasNote() {
    const { currentBrowsePageContent, currentGalleryFile } =
      this.rootStore.commonStore;
    if (currentBrowsePageContent && currentGalleryFile) {
      const element = currentBrowsePageContent.items.filter(
        (x) => x.fileId === currentGalleryFile.fileId
      )[0];
      return element && element.hasNote;
    } else return false;
  }

  get meetingYears() {
    let years: number[] = [];
    let meetings = Array.from(this.userMeetings.values());
    meetings.forEach((meeting) => {
      let meetingYear = moment(meeting.startDate).year();
      if (!years.includes(meetingYear)) {
        years.push(meetingYear);
      }
    });
    return years.sort((a, b) => a - b); // For ascending sort
  }

  //da ordinare
  orderedUserMeetings = (year: number) => {
    let meetings = Array.from(this.userMeetings.values());
    let filteredMeetings: IUserMeeting[] = [];
    meetings.forEach((meeting) => {
      if (moment(meeting.startDate).year() === year) {
        filteredMeetings.push(meeting);
      }
    });
    return filteredMeetings;
  };

  setUserMeetings = (meetings: IUserMeeting[]) => {
    let umList = new Map<number, IUserMeeting>();
    meetings.forEach((m) => {
      umList.set(m.id, m);
    });
    this.userMeetings = umList;
  };

  getMeeting = (meetingId: number) => {
    return this.userMeetings.get(meetingId);
  };

  loadLinks = async () => {
    try {
      const dto = await agent.Player.links();
      runInAction(() => {
        this.playerLinks = dto.links;
        this.canViewSurveys = dto.canViewSurvey;
        this.enabledRepository = dto.enabledRepository;
        this.enabledArchiveButton = dto.enabledArchive;
      });
      return dto;
    } catch (error) {
      console.log(error);
      throw error;
    }
  };

  loadOfflineLinks = () => {
    try {
      this.playerLinks = offlineLinks;
      return offlineLinks;
    } catch (error) {
      console.log(error);
      throw error;
    }
  };

  // showMeetingAttendanceModal = (meeting: IUserMeeting) => {

  //   if (this.attendingMeeting && this.attendingMeeting.id === meeting.id) {
      
  //     history.push(`meeting/${meeting.id}`);
  //   }
  //    else this.meetingAttendanceModal = meeting;
  // };

  showMeetingAttendanceModal = (meeting: IUserMeeting) => {
    var enabledODG= this.rootStore.tenantStore.canViewODG;
    var enabledMyDoc= this.rootStore.playerStore.enabledRepository;
   if (this.attendingMeeting && this.attendingMeeting.id === meeting.id) {
     if(enabledODG){
     history.push(`meeting/${meeting.id}`);
     }else{
       if(enabledMyDoc)
       history.push(`repository`);
       else
       history.push(`board`);}
   }
    else this.meetingAttendanceModal = meeting;
 };


  ShowRepository(){
    history.push(`repository`);
   }

  hideMeetingAttendanceModal = () => {
    this.meetingAttendanceModal = null;
  };

  setAttendingMeeting = (meetingId: number) => {
    // console.log("setAttendingMeeting", meetingId);
    let userMeeting = this.rootStore.playerStore.userMeetings.get(meetingId);
    if (userMeeting) {
      this.rootStore.playerStore.attendingMeeting = userMeeting;
    } else {
      this.rootStore.playerStore.attendingMeeting = null;
    }
  };

  setAttendingMeetingUsers = (users: IAttendingUser[]) => {
    if (this.attendingMeeting && users) {
      const usersMap = new Map<number, IAttendingUser>();
      users.forEach((u) => {
        usersMap.set(u.id, u);
      });
      this.attendingMeeting.users = usersMap;
    }
  };

  setCurrentSharingUser = (userId?: number) => {
    if (this.attendingMeeting) {
      this.attendingMeeting.sharingUserId = userId;
    } else {
      console.log("setCurrentSharingUser - no attending meeting");
    }
  };

  setShareSyncStatus = (status: number) => {
    if (this.attendingMeeting) {
      this.attendingMeeting.shareSyncStatus = status;
    }
  };

  addUserToMeeting = (user: IAttendingUser) => {
    if (this.attendingMeeting && this.attendingMeeting.users) {
      const alreadyAttending = this.attendingMeeting.users.get(user.id);
      if (!alreadyAttending) {
        this.attendingMeeting.users.set(user.id, user);
      }
    }
  };

  removeUserFromMeeting = (userId: number) => {
    if (this.attendingMeeting && this.attendingMeeting.users) {
      const toRemove = this.attendingMeeting.users.get(userId);
      if (toRemove) {
        this.attendingMeeting.users.delete(toRemove.id);
        if (
          this.rootStore.userStore.user &&
          toRemove.id === this.rootStore.userStore.user.id
        ) {
          this.rootStore.tenantStore.attendMeeting(this.attendingMeeting.id);
        }
      }
    }
  };

  setSynchronizationObject = (sharedObj: ISharedObject | null) => {
    this.synchronizationObject = sharedObj;
  };

  setSharedObject = () => {
    const file = this.rootStore.commonStore.currentGalleryFile;
    if (this.isSharing && this.attendingMeeting && file) {
      let data="";
      let command="";
      if(!this.rootStore.playerStore.isZoomPortionEnabled){
        command="";
       data = `/meetings/${this.attendingMeeting.id}/users/${
        this.attendingMeeting.sharingUserId
      }/sharing/${file.fileId}${file.type === "video" ? `?format=mp4` : ``}`;
    }else{
      command="zoomportion"
      const timeStamp = new Date().getMilliseconds()
      var sharinguser="";
      if(this.rootStore.guestStore.guestUsername)
      sharinguser= this.rootStore.guestStore.guestUsername
      else
      sharinguser= this.attendingMeeting.sharingUserId?.toString()??"";
      data = `/public/player/${
        sharinguser
      }/zoomPortionFile?ts=${timeStamp}`;

    }
      this.sharedObject = {
        fileId: file.fileId,
        type: file.type,
        data: data,
        command: command
      };
    }
  };

  resetSharedObject = () => {

    this.sharedObject= null;
  }

  setSharedWidget = () => {
    const file = this.rootStore.commonStore.currentGalleryFile;
    if (file) {
      switch (file.type) {
        case "image":
          this.setCurrentSharedWidgetImage(file.fileId);
          break;
        case "video":
          this.setCurrentSharedWidgetVideo(file.fileId, "");
          break;
        default:
          break;
      }
    } else this.sharedWidget = null;
  };

  setCurrentSharedWidgetImage = (fileId: number) => {
    const { isOnair } = this.rootStore.screensStore;
    const { CurrentZwibblerDrawing } = this.rootStore.zwibblerStore;
    if (isOnair && fileId > 0) {
      this.sharedWidget = {
        type: "image",
        fileId: fileId,
        zwibblerDrawing: CurrentZwibblerDrawing,
      };
    }
  };

  setCurrentSharedWidgetVideo = (
    fileId: number,
    status: VideoWidgetCommandTypes
  ) => {
    const { isOnair } = this.rootStore.screensStore;
    if (isOnair && fileId > 0) {
      this.sharedWidget = {
        type: "video",
        fileId: fileId,
        status: status,
      };
    }
  };

  setCurrentSharedWidgetScreenQR = (
    url: string,
    code: string,
    screenName: string
  ) => {
    const { isOnair } = this.rootStore.screensStore;
    if (isOnair) {
      this.sharedWidget = {
        type: "screenqr",
        url: url,
        code: code,
        screenName: screenName,
      };
    }
  };

  changeCurrentWidgetVideoCommand = (command: VideoWidgetCommandTypes) => {
    if (this.sharedWidget && this.sharedWidget.type === "video") {
      (this.sharedWidget as ISharedWidgetVideo).status = command;
    }
  };

  search = async (searchOptions: ISearchOptions) => {
    this.searching = true;
     const{canViewODG}= this.rootStore.tenantStore;
    try {
      if(!canViewODG) searchOptions.searchInMeetings= false;
      const dto = await agent.Player.searchAll(searchOptions);
      runInAction(() => {
        this.searchResults = dto;
        this.searching = false;
      });
      return dto;
    } catch (error) {
      console.log(error);
      runInAction(() => {
        this.searching = false;
      });
    }
  };

  setSelectedSearchPage = (value: number) => {
    this.selectedSearchPage = value;
  };

  openContentNoteModal = () => {
    const { currentBrowsePageContent } = this.rootStore.commonStore;
    if (currentBrowsePageContent) {
      this.noteModalParams = { contentId: currentBrowsePageContent.contentId };
      this.showNoteModal = true;
    }
  };

  openFileNoteModal = () => {
    const { currentGalleryFile } = this.rootStore.commonStore;
    const fileId = currentGalleryFile ? currentGalleryFile.fileId : 0;
    if (fileId > 0) {
      this.noteModalParams = { fileId: fileId };
      this.showNoteModal = true;
    }
  };

  closeShowNoteModal = () => {
    this.showNoteModal = false;
  };



  resetSearch = () => {
    this.searchResults = null;
  };

  resetAttendingMeeting = () => {
    this.meetingAttendanceModal = null;
    this.attendingMeeting = null;
  };

  resetNoteModalParams = () => {
    this.noteModalParams = null;
  };

  setActiveTab = (value: string) => {
    this.activeTab = value;
  };

  closeShowPresentationModal = () => {
    this.showPresentationModal = false;
  };

  openShowPresentationModal = () => {
    this.showPresentationModal = true;
  };


setZoomPortionEnabled =(state : boolean) => {
this.isZoomPortionEnabled= state;
}

zoomPortionCalculate = async (width: number, height: number, positionX: number , positionY : number) => {
  try {
      var info= new zoomPortionValue(); 
      var zw=  this.rootStore.zwibblerStore.zwibblerDivStyle;
      // console.log( "zwibbler:  _width: "+ zw.width  +" _height: "+ zw.height + " left " + zw.left  +  " _ top " + zw.top) ;
      var cropWidth= width
      var cropHeight= height
     //  console.log("cropWidth: " +cropWidth + "cropHeight: " +cropHeight);
      var zwibblerReal= this.rootStore.zwibblerStore.zwibblerCtx.getDocumentSize();
      if (this.rootStore.zwibblerStore.zwibblerCtx && this.rootStore.zwibblerStore.currentContainer){
          const containerWidth = this.rootStore.zwibblerStore.currentContainer.clientWidth;
          const containerHeight = this.rootStore.zwibblerStore.currentContainer.clientHeight;
          const ratio = containerWidth / containerHeight;
          var ratioImg =
            this.rootStore.zwibblerStore.currentOriginalImageSize.width /
            this.rootStore.zwibblerStore.currentOriginalImageSize.height;
          if (ratioImg >= ratio) {
          //  console.log("zw.left=0  zw.top=Y"); 
              var calculateratio = zw.width/ zwibblerReal.width; 
              var calculatepositionY=   positionY-zw.top;
              var calculatepositionX= positionX
                // console.log(" calculatepositionX: " +calculatepositionX);
                 info.imageZwibbler=  this.rootStore.zwibblerStore.zwibblerCtx.save('png',
                 {x: ( calculatepositionX)/ calculateratio , y: ( calculatepositionY) / calculateratio ,   width:  ( cropWidth)/calculateratio, height: (cropHeight )/ calculateratio  });
                 info.cropX= calculatepositionX;
                 info.cropY= calculatepositionY;
                 info.cropHeight= cropHeight;
                 info.cropWidth=  cropWidth;
                 info.contanierWidth= zw.width;
          }else{
              //  console.log("zw.left=x  zw.top=0"); 
              // console.log("position X iniziale" + positionX);
                 var calculateratio = zw.width/ zwibblerReal.width; 
                 var calculatepositionX=   positionX - zw.left
                 var calculatepositionY= positionY
              //   console.log(" calculatepositionX: " +calculatepositionX);
              //  console.log("position Y iniziale: " + positionY);
              // console.log(" calculatepositionY: " + calculatepositionY);
                info.imageZwibbler=  this.rootStore.zwibblerStore.zwibblerCtx.save('png',
                {x: ( calculatepositionX)/ calculateratio , y: ( calculatepositionY) / calculateratio ,   width:  ( cropWidth)/calculateratio, height: (cropHeight )/ calculateratio  });
                info.cropX= calculatepositionX;
                info.cropY= calculatepositionY;
                info.cropHeight= cropHeight;
                info.cropWidth=  cropWidth;
                info.contanierWidth= zw.width;
            }
        }
       
     info.fileId= this.rootStore.commonStore.currentGalleryFile?.fileId??0;
     if(this.rootStore.guestStore.guestUsername)
     info.guestUsername= this.rootStore.guestStore.guestUsername;
      await agent.Player.zoomPortion(info).then(() => { 
          this.setSharedObject()
            this.rootStore.tenantStore.sendSharedWidget();
          }).catch();

     
    } catch (error) {
      console.log(error);
   
    }
  };

 
}


